<template>
  <div style="margin-bottom: -1rem !important;">
    <multiselect-ajax
      v-if="regions.includes('province')"
      class="mb-3"
      name="province_id"
      :value="provinceValue"
      @input="onInput"
      :selected.sync="province"
      :url="'/jala/provinces?country_id__in=' + (countryId || 'ID')">
    </multiselect-ajax>
    <multiselect-ajax
      v-if="provinceValue && regions.includes('regency')"
      :key="`${_uid}-select-regencies-${provinceValue}`"
      class="mb-3"
      name="regency_id"
      :value="regencyValue"
      @input="(v) => onInput(v || provinceValue)"
      :selected.sync="regency"
      :url="`/jala/provinces/${provinceValue}/regencies`">
    </multiselect-ajax>
    <multiselect-ajax
      v-if="regencyValue && regions.includes('district')"
      :key="`${_uid}-select-districts-${regencyValue}`"
      class="mb-3"
      name="district_id"
      :value="districtValue"
      @input="(v) => onInput(v || regencyValue)"
      :selected.sync="district"
      :url="`/jala/regencies/${regencyValue}/districts`">
    </multiselect-ajax>
    <multiselect-ajax
      v-if="districtValue && regions.includes('village')"
      :key="`${_uid}-select-villages-${districtValue}`"
      class="mb-3"
      name="village_id"
      :value="villageValue"
      @input="(v) => onInput(v || districtValue)"
      :selected.sync="village"
      :url="`/jala/districts/${districtValue}/villages`">
    </multiselect-ajax>
  </div>
</template>

<script>
import MultiselectAjax from "./vue-multiselect-ajax";

export default {
  name: "jala-region-select-ajax",
  components: {
    MultiselectAjax
  },
  props:{
    value: {
      type: String,
      default: undefined
    },
    countryId: {
      type: String,
      default: 'ID'
    },
    regions: {
      type: Array,
      default: () => [
        'province',
        'regency',
        'district',
        'village'
      ]
    }
  },
  data() {
    return {
      province: null,
      regency: null,
      district: null,
      village: null
    }
  },
  computed: {
    provinceValue() {
      return (this.value || '').slice(0, 2);
    },
    regencyValue() {
      const regencyId = (this.value || '').slice(0, 4);
      return regencyId.length === 4 ? regencyId : '';
    },
    districtValue() {
      const districtId = (this.value || '').slice(0, 7);
      return districtId.length === 7 ? districtId : '';
    },
    villageValue() {
      const villageId = (this.value || '').slice(0, 10);
      return villageId.length === 10 ? villageId : '';
    }
  },
  watch: {
    province(event) {
      if (!event)
        this.regency = null;
      this.$nextTick(() => {
        this.$emit('update:selected', event)
      })
    },
    regency(event) {
      if (!event)
        this.district = null;
      this.$nextTick(() => {
        this.$emit('update:selected', event || this.province)
      })
    },
    district(event) {
      if (!event)
        this.village = null;
      this.$nextTick(() => {
        this.$emit('update:selected', event || this.regency)
      })
    },
    village(event) {
      if (!event)
        this.regency = null;
      this.$emit('update:selected', event || this.district)
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
